import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../App';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_confusing-preview/artifacts/gu4q9ocf_trans_white_logo.png";

const SplashScreen = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isAdminAuthenticated, isLoading } = useAuth();
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    // Fade in animation
    const timer = setTimeout(() => setShowContent(true), 100);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!isLoading) {
      const redirectTimer = setTimeout(() => {
        if (isAdminAuthenticated) {
          navigate('/admin');
        } else if (isAuthenticated) {
          navigate('/home');
        } else {
          navigate('/login');
        }
      }, 2000);
      
      return () => clearTimeout(redirectTimer);
    }
  }, [isLoading, isAuthenticated, isAdminAuthenticated, navigate]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex flex-col items-center justify-center relative overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-primary/10 via-transparent to-transparent" />
      
      {/* Content */}
      <div className={`flex flex-col items-center transition-all duration-700 ${showContent ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
        {/* Logo */}
        <div className="relative mb-8">
          <div className="absolute inset-0 bg-primary/20 blur-3xl rounded-full scale-150" />
          <img 
            src={LOGO_URL} 
            alt="LekeeWallet" 
            className="h-24 w-auto relative z-10"
            data-testid="splash-logo"
          />
        </div>
        
        {/* Wallet text */}
        <h1 className="text-2xl font-bold text-white tracking-tight mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
          LekeeWallet
        </h1>
        
        {/* Tagline */}
        <p className="text-muted-foreground text-base mb-12">
          Your money. Your platform. Your power.
        </p>
        
        {/* Loading indicator */}
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 rounded-full bg-primary animate-bounce" style={{ animationDelay: '0ms' }} />
          <div className="w-2 h-2 rounded-full bg-primary animate-bounce" style={{ animationDelay: '150ms' }} />
          <div className="w-2 h-2 rounded-full bg-primary animate-bounce" style={{ animationDelay: '300ms' }} />
        </div>
      </div>
      
      {/* Footer */}
      <div className="absolute bottom-8 text-center">
        <p className="text-xs text-muted-foreground">
          Part of the LekeeLekee ecosystem
        </p>
      </div>
    </div>
  );
};

export default SplashScreen;
